/* eslint-disable jsx-a11y/iframe-has-title */
import { Col, Pagination, Row } from 'reactstrap'
import { H5, LI, UL } from '../../../../../AbstractElements'
import { SearchResultInitialState } from '../../../../../Types/SearchResultType'
import { Href, VideoTabTitle } from '../../../../../Utils/Constants'

export default function VideoTab({ allResult }: SearchResultInitialState) {

    return (
        <Row className='gy-3'>
            <H5 className="f-w-700 mb-2">{VideoTabTitle}</H5>
            {allResult &&
                allResult.map((item) => (
                    <Col xxl={6} key={item.id}>
                        <div className="d-flex info-block">
                            <iframe className="me-3 mb-3" width="200" height="100" src={item.videoLink}></iframe>
                            <div className="flex-grow-1">
                                <a href={Href}>{item.url}</a>
                                <H5>{item.title}</H5>
                                <div className="star-ratings">
                                    <UL className="simple-list flex-row search-info flex-wrap">
                                        <LI>{item.star}</LI>
                                        <LI>{item.vote}</LI>
                                        <LI>{item.news}</LI>
                                    </UL>
                                </div>
                            </div>
                        </div>
                    </Col>
                ))}
            <Pagination />
        </Row>
    )
}
